import React, { useEffect } from 'react';

const MOMAuthCallback = () => {
  useEffect(() => {
    try {
      // Extract code from URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');
      
      console.log('Popup callback - code:', code ? 'received' : 'missing');
      console.log('Popup callback - state:', state);
      console.log('Popup callback - error:', error);
      
      if (window.opener && !window.opener.closed) {
        if (error) {
          // Send error to parent window
          window.opener.postMessage({
            type: 'MOM_AUTH_ERROR',
            error: error
          }, '*');
        } else if (code) {
          // Send success to parent window (don't check state here)
          window.opener.postMessage({
            type: 'MOM_AUTH_SUCCESS',
            code: code
          }, '*');
        } else {
          // Send generic error
          window.opener.postMessage({
            type: 'MOM_AUTH_ERROR',
            error: 'Invalid authentication response'
          }, '*');
        }
      } else {
        console.error('No opener window found');
      }
      
      // Close popup after a short delay
      setTimeout(() => {
        window.close();
      }, 1000);
      
    } catch (err) {
      console.error('Popup callback error:', err);
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({
          type: 'MOM_AUTH_ERROR',
          error: 'Callback processing failed'
        }, '*');
      }
      window.close();
    }
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Authentication complete. This window will close automatically...</p>
    </div>
  );
};

export default MOMAuthCallback;